import { wOrgIdMiddleware } from '../utils/commonUtils';
import { OK } from '../utils/constant';
import http from './http';

const MedicationService = {
  // Save medication
  saveMedication: wOrgIdMiddleware(async (url, data) => {
    try {
      const response = await http.POST(`${url}medications`, data);
      return response;
    } catch (error) {
      console.error('Error saving medication:', error);
      if (error.status) {
        const resData = error.data;
        if (resData.code && resData.data) {
          return resData;
        }
      }
    }
  }, true),

  // Get medication by ID
  getMedicationById: wOrgIdMiddleware(async (url, medicationId) => {
    try {
      const response = await http.GET(`${url}medications/${medicationId}`);
      if (response.code === OK) {
        return response.data;
      }
    } catch (error) {
      if (error.status) {
        const resData = error.data;
        if (resData.code && resData.data) {
          return resData;
        }
      }
    }
  }),

  // Get medications list
  getMedications: wOrgIdMiddleware(async (url, query = {}) => {
    const queryString = new URLSearchParams(query).toString();
    try {
      const response = await http.GET(`${url}medications?${queryString}`);
      if (response.code === OK) {
        return response.data;
      }
    } catch (error) {
      if (error.status) {
        const resData = error.data;
        if (resData.code && resData.data) {
          return resData;
        }
      }
    }
  }, true),

  // Get all medications without pagination
  getAllMedications: wOrgIdMiddleware(async (url, query = {}) => {
    const queryString = new URLSearchParams(query).toString();
    try {
      const response = await http.GET(`${url}medications/all?${queryString}`);
      if (response.code === OK) {
        return response.data;
      }
    } catch (error) {
      if (error.status) {
        const resData = error.data;
        if (resData.code && resData.data) {
          return resData;
        }
      }
    }
  }, true),

  // Update medication
  updateMedication: wOrgIdMiddleware(async (url, id, data) => {
    try {
      const response = await http.PUT(`${url}medications/${id}`, data);
      return response;
    } catch (error) {
      if (error.status) {
        const resData = error.data;
        if (resData.code && resData.data) {
          return resData;
        }
      }
      console.error('Error updating medication:', error);
      throw error;
    }
  }),

  // Delete medication
  deleteMedication: wOrgIdMiddleware(async (url, id) => {
    try {
      const response = await http.DELETE(`${url}medications/${id}`);
      return response;
    } catch (error) {
      if (error.status) {
        const resData = error.data;
        if (resData.code && resData.data) {
          return resData;
        }
      }
      console.error('Error deleting medication:', error);
      throw error;
    }
  }),
};

export default MedicationService;

